import { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import {
  getProjectTempConfig,
  getProjectTempConfigDate,
  setProjectTempConfig,
  setProjectTempConfigDate,
} from "../../../ducks/projectConfig";
import { useAction } from "../../../hooks/useAction";
import { ProjectInfo } from "../../../interfaces/resourceInfo";

export const useProjectTempConfig = () => {
  const setTempConfig = useAction(setProjectTempConfig);
  const setTempConfigDate = useAction(setProjectTempConfigDate);
  const tempConfig = useSelector(getProjectTempConfig);
  const tempConfigDate = useSelector(getProjectTempConfigDate);
  const tempConfigDateRef = useRef(tempConfigDate);

  const onChangeTempConfig = useCallback(
    (info: ProjectInfo) => {
      setTempConfig(info);

      if (tempConfigDateRef.current) {
        if (!info) {
          setTempConfigDate(null);
        }
      } else {
        setTempConfigDate(new Date());
      }
    },
    [setTempConfig, setTempConfigDate],
  );

  useEffect(() => {
    tempConfigDateRef.current = tempConfigDate;
  }, [tempConfigDate]);

  return [tempConfig, onChangeTempConfig] as const;
};
